// extracted by mini-css-extract-plugin
export var addressSummary = "forms-module--addressSummary--b9dc8";
export var form = "forms-module--form--3273c";
export var intro = "forms-module--intro--8987b";
export var splitRow = "forms-module--splitRow--43ace";
export var successMessage = "forms-module--success-message--baee0";